import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=6dab700e&scoped=true&"
import script from "./discover.vue?vue&type=script&lang=js&"
export * from "./discover.vue?vue&type=script&lang=js&"
import style0 from "./discover.vue?vue&type=style&index=0&id=6dab700e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dab700e",
  null
  
)

export default component.exports